import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.scss";
import AppState from "./context/state";
// Pages
import Main from "./pages/main/main";
import Login from "./pages/login/login";
import Preview from "./pages/preview";
import Landing from "./pages/landing/landing";
import Privacy from "./pages/privacy/privacy";

const theme = createTheme({
  palette: {
    primary: {
      main: "#050f66",
    },
    secondary: {
      main: "#ff6551",
    },
  },
});


const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="app-main">
        <AppState>
          <Router>
            <Switch>
              <Route exact path="/play/:channel" component={Preview} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/logout" component={Login} />
              <Route exact path="/privacy" component={Privacy} />
              <Route path="/app/" component={Main} />
              <Route exact path="" component={Landing} />
            </Switch>
          </Router>
        </AppState>
      </div>
    </ThemeProvider>
  );
};

export default App;